import WallexService from './WallexService'
import { UserRetrieve, UserUpdatePayload } from '../domain/User'

export default class UserService extends WallexService {
    public static retrieve(userId: string): Promise<UserRetrieve> {
        return this.instance()
            .get('users/' + userId)
            .then((response) => {
                const body = response.data as {
                    result: UserRetrieve
                }

                return body.result
            })
    }

    public static update(userId: string, payload: UserUpdatePayload) {
        return this.instance()
            .patch('users/' + userId, payload)
            .then((response) => {
                const body = response.data as {
                    result: UserRetrieve
                }

                return body.result
            })
    }
}
